export const HR_INSURANCE_BENEFIT_PERMISSION_CODES = {
    WEB_HR_INSURANCE_BENEFIT_LIST: 'WEB_HR_INSURANCE_BENEFIT_LIST',
    WEB_HR_INSURANCE_BENEFIT_DETAIL: 'WEB_HR_INSURANCE_BENEFIT_DETAIL',
    WEB_HR_INSURANCE_BENEFIT_ADD: 'WEB_HR_INSURANCE_BENEFIT_ADD',
    WEB_HR_INSURANCE_BENEFIT_EDIT: 'WEB_HR_INSURANCE_BENEFIT_EDIT',
    WEB_HR_INSURANCE_BENEFIT_DELETE: 'WEB_HR_INSURANCE_BENEFIT_DELETE',
    WEB_HR_INSURANCE_BENEFIT_IMPORT: 'WEB_HR_INSURANCE_BENEFIT_IMPORT',
    WEB_HR_INSURANCE_BENEFIT_EXPORT: 'WEB_HR_INSURANCE_BENEFIT_EXPORT',
} as const;

